"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWithInputGroupInText = exports.CloseInactiveTopicsPanelHeader = exports.CloseInactiveTopicsPanelBody = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _PanelItems = require("../registration-rules/PanelItems");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var _Filters = require("@insided/control/modules/ContentModeration/ContentOverviews/Filters");

var _index = require("./index");

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var CloseInactiveTopicsPanelBody = function CloseInactiveTopicsPanelBody(_ref) {
  var isCloseInactiveTopicsEnabled = _ref.isCloseInactiveTopicsEnabled,
      closeTopicsIn = _ref.closeTopicsIn,
      selectedCategories = _ref.selectedCategories,
      categoriesV2 = _ref.categoriesV2,
      showCategoryDropdown = _ref.showCategoryDropdown,
      onInputChange = _ref.onInputChange,
      onInputFocus = _ref.onInputFocus,
      onInputBlur = _ref.onInputBlur,
      onCloseInactiveTopicsSettingChanged = _ref.onCloseInactiveTopicsSettingChanged,
      onSelectedCategoriesChanged = _ref.onSelectedCategoriesChanged,
      onResetCategories = _ref.onResetCategories,
      categoryDropdownId = _ref.categoryDropdownId,
      showValidationError = _ref.showValidationError,
      showActionButtons = _ref.showActionButtons,
      onCancel = _ref.onCancel,
      onSave = _ref.onSave,
      selectedOption = _ref.selectedOption,
      toggleCategoryDropdown = _ref.toggleCategoryDropdown,
      handleOptionChange = _ref.handleOptionChange;
  var isInputEnabled = !isCloseInactiveTopicsEnabled;
  var selectedCategoriesLength = selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.length;
  var categoriesPlaceholderText = // eslint-disable-next-line no-nested-ternary
  selectedCategoriesLength === 0 ? 'Select categories' : selectedCategoriesLength === 1 ? "".concat(selectedCategoriesLength, " category selected") : "".concat(selectedCategoriesLength, " categories selected");

  var _createPublishedInFil = (0, _Filters.createPublishedInFilter)(categoriesV2),
      CategoriesSelector = _createPublishedInFil.component,
      items = _createPublishedInFil.items;

  return (0, _preact.h)("div", {
    className: "panel-close-inactive-topics"
  }, (0, _preact.h)("div", {
    className: "switch-icon-container"
  }, (0, _preact.h)(_Switcher.default, {
    on: isCloseInactiveTopicsEnabled,
    customClass: "panel-switch",
    labelCustomClass: "panel-switch-label panel-close-inactive-topics-switch",
    label: "Enable this automation",
    onChange: function onChange() {
      return onCloseInactiveTopicsSettingChanged(!isCloseInactiveTopicsEnabled);
    }
  })), (0, _preact.h)("div", {
    className: "panel-switch"
  }, (0, _preact.h)(LabelWithInputGroupInText, {
    isInputEnabled: isInputEnabled,
    ageInDays: closeTopicsIn,
    onInputChange: onInputChange,
    onInputFocus: onInputFocus,
    onInputBlur: onInputBlur,
    hasError: showValidationError
  }), showValidationError && !closeTopicsIn && (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message"
  }, "Please fill in the required field"))), (0, _preact.h)("div", {
    className: "panel-radio-group"
  }, (0, _preact.h)(_RadioInputGroup.default, {
    title: "Select how the feature should behave",
    options: [_index.CategoryOptions.ALL, _index.CategoryOptions.CUSTOM],
    onChange: function onChange(_, idx) {
      return handleOptionChange(idx === 0 ? _index.CategoryOptions.ALL : _index.CategoryOptions.CUSTOM, categoryDropdownId);
    },
    value: selectedOption,
    withRadioIcons: true,
    underneath: true,
    disabled: !isCloseInactiveTopicsEnabled
  })), (0, _preact.h)("div", {
    className: "panel-input-dropdown-container"
  }, (0, _preact.h)(_Button.default, {
    disabled: selectedOption !== _index.CategoryOptions.CUSTOM || !isCloseInactiveTopicsEnabled,
    title: (0, _preact.h)("div", null, (0, _preact.h)("span", {
      className: "dropdown-placeholder-text"
    }, categoriesPlaceholderText), (0, _preact.h)(_assets.default, {
      icon: "chevronDown",
      height: 16,
      width: 16
    })),
    size: "medium",
    className: "close-inactive-topics-category-open-button ".concat(showCategoryDropdown ? 'dropdown-open' : '', " "),
    onClick: function onClick() {
      return toggleCategoryDropdown(!showCategoryDropdown);
    }
  }), (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.length) === 0 && selectedOption === _index.CategoryOptions.CUSTOM && (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message"
  }, "Please select at least one category")), showCategoryDropdown && selectedOption === _index.CategoryOptions.CUSTOM && (0, _preact.h)("div", {
    className: "overview__filters-box-container"
  }, (0, _preact.h)("div", {
    className: "overview__filters-box"
  }, (0, _preact.h)(CategoriesSelector, {
    id: "category",
    name: "Rule",
    items: items,
    selectedFilterItems: selectedCategories,
    disableApplyButton: false
  }, function (_ref2) {
    var isApplyButtonDisabled = _ref2.isApplyButtonDisabled,
        data = _ref2.data;
    return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
      className: "overview__filters-box-buttons"
    }, (0, _preact.h)(_Button.default, {
      size: "small",
      variant: "brand",
      title: "Apply",
      disabled: isApplyButtonDisabled,
      onClick: function onClick() {
        return onSelectedCategoriesChanged(categoryDropdownId, data);
      }
    }), (0, _preact.h)(_Button.default, {
      size: "small",
      title: "Cancel",
      onClick: function onClick() {
        return onResetCategories();
      }
    })));
  })))), showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: onSave,
    onCancel: onCancel
  }));
};

exports.CloseInactiveTopicsPanelBody = CloseInactiveTopicsPanelBody;

var LabelWithInputGroupInText = function LabelWithInputGroupInText(_ref3) {
  var isInputEnabled = _ref3.isInputEnabled,
      ageInDays = _ref3.ageInDays,
      onInputChange = _ref3.onInputChange,
      onInputFocus = _ref3.onInputFocus,
      hasError = _ref3.hasError,
      onInputBlur = _ref3.onInputBlur;
  return (0, _preact.h)("div", {
    className: "panel-input-label"
  }, "After a topic is inactive for", ' ', (0, _preact.h)(_InputGroup.default, {
    type: "number",
    min: 1,
    required: true,
    disabled: isInputEnabled,
    value: ageInDays,
    hasError: hasError,
    onChange: function onChange(e) {
      return onInputChange(e.target.value);
    },
    onClick: onInputFocus,
    onBlur: onInputBlur,
    qaClasses: "qa-close-topic-age-in-days-input"
  }), ' ', "days, close the topic for new replies. This", ' ', (0, _preact.h)("a", {
    href: "https://communities.gainsight.com/moderating-content-33/how-to-automatically-close-inactive-topics-19877",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "community article"), ' ', "explains the feature in more detail.");
};

exports.LabelWithInputGroupInText = LabelWithInputGroupInText;

var CloseInactiveTopicsPanelHeader = function CloseInactiveTopicsPanelHeader(_ref4) {
  var statusText = _ref4.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "noReply",
    title: "Automatically close inactive topics",
    statusText: statusText
  });
};

exports.CloseInactiveTopicsPanelHeader = CloseInactiveTopicsPanelHeader;